import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DataValidator } from 'app/tools/custom-formgroup-validator';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'date-final-situacao',
  templateUrl: './date-final-situacao.component.html',
  styleUrls: ['./date-final-situacao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DateFinalSituacaoComponent implements OnInit {

  @Input() params: any;
  @Output() dateChanged: EventEmitter<any> = new EventEmitter<any>();
  now: string = new Date().toISOString().split('T')[0];
  dtInativacao: FormControl = new FormControl();

  constructor() { }

  ngOnInit() {
    this.dtInativacao.valueChanges.subscribe(value => this.dateChanged.emit(value));
  }

  async ngAfterViewInit(){
    this._validators();
  }

  private _validators(){
    const date = new Date();
    date.setHours(23, 59, 59, 59);
    this.dtInativacao.setValidators([Validators.required, DataValidator.min(this.params.dtAtivacao)]);
    this.dtInativacao.updateValueAndValidity();
  }
}
